import React from "react";
import { useNavigate } from "react-router-dom";
import "./BackLink.css";

export default function BackLink({ label = "Πίσω", fallbackTo = "/" }) {
  const navigate = useNavigate();

  const handleBack = () => {
    // Если страница явно сказала, куда возвращаться,
    // например чат пришёл из объявления: /ads/123,
    // идём туда напрямую. Это стабильнее для новой вкладки.
    if (fallbackTo && fallbackTo !== "/") {
      navigate(fallbackTo);
      return;
    }

    const hasPreviousPage =
      window.history.length > 1 &&
      document.referrer &&
      document.referrer.includes(window.location.origin);

    if (hasPreviousPage) {
      navigate(-1);
    } else {
      navigate("/");
    }
  };

  return (
    <div className="back-link-wrapper">
      <button type="button" className="back-link" onClick={handleBack}>
        <span className="back-arrow">←</span>
        <span className="back-text">{label}</span>
      </button>
    </div>
  );
}